export default __webpack_public_path__ + "static/media/YAS0190.34I-23060_-24477_0.b0568750.jpg";